var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOutlineHomeWork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08325 33.9167V64.75H21.5833V49.3333H27.7499V64.75H46.2499V33.9167L24.6666 18.5L3.08325 33.9167ZM40.0833 58.5833H33.9166V43.1667H15.4166V58.5833H9.24992V37.0925L24.6666 26.085L40.0833 37.0925V58.5833ZM52.4166 21.5833H58.5833V27.75H52.4166V21.5833ZM52.4166 33.9167H58.5833V40.0833H52.4166V33.9167ZM52.4166 46.25H58.5833V52.4167H52.4166V46.25Z",
    fill: "#004B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 9.25V15.3242L36.9999 19.7333V15.4167H64.7499V58.5833H52.4166V64.75H70.9166V9.25H30.8333Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineHomeWork);
export default __webpack_public_path__ + "static/media/ic_outline-home-work.5bb28407efeacdc9639466f0a68bdb78.svg";
export { ForwardRef as ReactComponent };